import React, { useState } from 'react';
import { CalendarIcon, ClockIcon, LaptopIcon, AlertCircleIcon, ArrowDownIcon } from 'lucide-react';
import { YtMartesRegistrationModal } from './YtMartesRegistrationModal';
interface CTASectionProps {
  setShowThankYou: (show: boolean) => void;
}
export function YtMartesCTASection({
  setShowThankYou
}: CTASectionProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleSuccess = () => {
    setIsModalOpen(false);
    setShowThankYou(true);
  };
  return <>
      <section className="text-center" data-id="element-1028">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold mb-8 text-center leading-tight" data-id="element-1029">
          Detalles de la Masterclass
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 lg:gap-8 mb-8 md:mb-12 lg:mb-16" data-id="element-1030">
          <div className="bg-red-900 bg-opacity-30 p-6 md:p-8 lg:p-10 rounded-xl md:rounded-2xl flex flex-col items-center transition-transform hover:scale-105" data-id="element-1031">
            <CalendarIcon className="h-10 w-10 md:h-12 md:w-12 text-red-400 mb-4 md:mb-6" data-id="element-1032" />
            <p className="text-base md:text-lg lg:text-xl font-medium leading-relaxed" data-id="element-1033">
              <span className="block font-bold text-xl md:text-2xl mb-2" data-id="element-1034">
                Día
              </span>
              Martes, 6 de enero
            </p>
          </div>
          <div className="bg-red-900 bg-opacity-30 p-6 md:p-8 lg:p-10 rounded-xl md:rounded-2xl flex flex-col items-center transition-transform hover:scale-105" data-id="element-1035">
            <ClockIcon className="h-10 w-10 md:h-12 md:w-12 text-red-400 mb-4 md:mb-6" data-id="element-1036" />
            <p className="text-base md:text-lg lg:text-xl font-medium leading-relaxed" data-id="element-1037">
              <span className="block font-bold text-xl md:text-2xl mb-2" data-id="element-1038">
                Hora
              </span>
              7:00 PM (Hora del Este)
            </p>
          </div>
          <div className="bg-red-900 bg-opacity-30 p-6 md:p-8 lg:p-10 rounded-xl md:rounded-2xl flex flex-col items-center transition-transform hover:scale-105" data-id="element-1039">
            <LaptopIcon className="h-10 w-10 md:h-12 md:w-12 text-red-400 mb-4 md:mb-6" data-id="element-1040" />
            <p className="text-base md:text-lg lg:text-xl font-medium leading-relaxed" data-id="element-1041">
              <span className="block font-bold text-xl md:text-2xl mb-2" data-id="element-1042">
                Formato
              </span>
              100% Online y en vivo
            </p>
          </div>
        </div>

        <div className="flex flex-col items-center space-y-6 md:space-y-8" data-id="element-1043">
          <p className="text-base md:text-lg text-gray-300 px-4" data-id="element-1044">
            Duración aproximada: 90 minutos
          </p>

          <div className="flex items-center px-4" data-id="element-1045">
            <AlertCircleIcon className="h-6 w-6 md:h-7 md:w-7 text-yellow-500 mr-2 md:mr-3 flex-shrink-0" data-id="element-1046" />
            <p className="text-lg sm:text-xl md:text-2xl font-semibold text-yellow-300" data-id="element-1047">
              Los cupos están limitados para garantizar una mejor experiencia en
              vivo.
            </p>
          </div>
          <div className="flex items-center px-4" data-id="element-1048">
            <ArrowDownIcon className="h-6 w-6 md:h-7 md:w-7 text-white mr-2 md:mr-3 flex-shrink-0" data-id="element-1049" />
            <p className="text-lg sm:text-xl md:text-2xl" data-id="element-1050">
              Te recomendamos registrarte con anticipación.
            </p>
          </div>

          <div className="w-full max-w-3xl px-4 mx-auto" data-id="element-1051">
            <button onClick={() => setIsModalOpen(true)} className="w-full bg-red-600 hover:bg-red-700 active:bg-red-800 text-white text-lg sm:text-xl md:text-2xl font-bold py-4 md:py-5 px-8 md:px-12 shadow-2xl transform hover:scale-105 active:scale-95 transition-all duration-300 flex items-center justify-center touch-manipulation" data-id="element-1052">
              RESERVA TU LUGAR GRATIS
              <span className="ml-2 md:ml-3 text-xl md:text-2xl" data-id="element-1053">→</span>
            </button>
          </div>
          <div className="w-full max-w-3xl px-4 mx-auto mt-6 md:mt-8" data-id="element-1054">
            <img src="https://cdn.magicpatterns.com/uploads/1cVYLqSP4PbWDgrRQPU8aV/tmp5djoo1mh.webp" alt="Guía de Implementación" className="w-full h-auto" data-id="element-1055" />
          </div>
        </div>
      </section>
      <YtMartesRegistrationModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} onSuccess={handleSuccess} data-id="element-1056" />
    </>;
}